module.exports = __webpack_public_path__ + "img/pt-38.21537393.jpg";